export const AREA_PREVIEW_IMAGES = {
  recv: {
    label: "原材料驗收區",
    img: "/img/products/B2B/area-preview/recv.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  rstore: {
    label: "原材料貯存區",
    img: "/img/products/B2B/area-preview/rstore.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  additives: {
    label: "食品添加物貯存區",
    img: "",
    objectfit: "cover",
    imgPosition: "center",
  },
  fstore: {
    label: "成品貯存區",
    img: "/img/products/B2B/area-preview/fstore.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  ship: {
    label: "出貨區",
    img: "/img/products/B2B/area-preview/ship.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  "personel-left": {
    label: "人員消毒區",
    img: "", // "/img/products/B2B/area-preview/handwash.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  "personel-right": {
    label: "人員消毒區",
    img: "", // "/img/products/B2B/area-preview/handwash.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  handwash: {
    label: "洗手區",
    img: "/img/products/B2B/area-preview/handwash.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  waste: {
    label: "廢棄物區",
    img: "/img/products/B2B/area-preview/waste.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  pre: {
    label: "前處理區",
    img: "/img/products/B2B/area-preview/pre.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  cook: {
    label: "加工調理區",
    img: "/img/products/B2B/area-preview/cook.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  pack: {
    label: "包裝區",
    img: "/img/products/B2B/area-preview/pack.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  clean: {
    label: "浴塵室",
    img: "/img/products/B2B/area-preview/clean.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  "locker-male": {
    label: "男更衣室",
    img: "/img/products/B2B/area-preview/locker.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  "locker-female": {
    label: "女更衣室",
    img: "/img/products/B2B/area-preview/locker-f.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  restroom: {
    label: "洗手間",
    img: "/img/products/B2B/area-preview/restroom.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  office: {
    label: "辦公區",
    img: "/img/products/B2B/area-preview/office.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
};

export const INDUSTRY_PREVIEW_IMAGES = {
  "food-factory": {
    label: "食品工廠",
    img: "/img/products/B2B/industry01.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  "chain-restaurant": {
    label: "餐飲連鎖",
    img: "/img/products/B2B/industry02.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  hyper: {
    label: "量販店",
    img: "/img/products/B2B/industry03.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  "super-conv": {
    label: "超市/便利超商",
    img: "/img/products/B2B/industry04.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  hotel: {
    label: "飯店/民宿",
    img: "/img/products/B2B/industry05.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
};

export const HUMAN_PART_PREVIEW_IMAGES = {
  head: {
    label: "頭",
    img: "/img/products/B2B/head.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  hand: {
    label: "手",
    img: "/img/products/B2B/hand.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  body: {
    label: "身",
    img: "/img/products/B2B/body.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  foot: {
    label: "腳",
    img: "/img/products/B2B/foot.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
};

export const GROUP_PREVIEW_IMAGES = {
  "hand-wash": {
    label: "洗手和手部消毒",
    img: "/img/products/b2b/group-preview/handwash-preview.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  chemicals: {
    label: "食品衛生化學品",
    img: "/img/products/b2b/group-preview/chemicals-preview.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  "equipment-cleaning": {
    label: "器械清潔",
    img: "/img/products/b2b/group-preview/equipment-cleaning-preview.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  disposable: {
    label: "一次性衛生耗材",
    img: "/img/products/b2b/group-preview/disposable-preview.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  equipment: {
    label: "設備",
    img: "/img/products/b2b/group-preview/equipment-preview.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
  tools: {
    label: "工具",
    img: "/img/products/b2b/group-preview/tools-preview.webp",
    objectfit: "cover",
    imgPosition: "center",
  },
};

const normalizePreviewHref = (href) => {
  try {
    return decodeURI(String(href || ""))
      .replace(/^\/+/, "")
      .replace(/^b2b\//, "")
      .replace(/^b2c\//, "")
      .replace(/\/+$/, "");
  } catch {
    return String(href || "")
      .replace(/^\/+/, "")
      .replace(/^b2b\//, "")
      .replace(/^b2c\//, "")
      .replace(/\/+$/, "");
  }
};

const previewMatch = (href, map, images, type) => {
  const normalizedHref = normalizePreviewHref(href);

  const matchedEntry = Object.entries(map).find(([prefix]) => {
    const normalizedPrefix = normalizePreviewHref(prefix);
    return (
      normalizedHref === normalizedPrefix ||
      normalizedHref.startsWith(`${normalizedPrefix}/`)
    );
  });

  if (!matchedEntry) return null;

  const [, key] = matchedEntry;
  const item = images[key];

  return item ? { ...item, key, type } : null;
};

const INDUSTRY_HREF_TO_PREVIEW_KEY = {
  "商品資訊/產業類別/食品工廠": "food-factory",
  "商品資訊/產業類別/餐飲連鎖": "chain-restaurant",
  "商品資訊/產業類別/連鎖餐廳": "chain-restaurant",
  "商品資訊/產業類別/量販店": "hyper",
  "商品資訊/產業類別/超市|便利超商": "super-conv",
  "商品資訊/產業類別/飯店|民宿": "hotel",
};

const HUMAN_PART_HREF_TO_PREVIEW_KEY = {
  "商品資訊/人體接觸/頭": "head",
  "商品資訊/人體接觸/手": "hand",
  "商品資訊/人體接觸/身體": "body",
  "商品資訊/人體接觸/腳": "foot",
};

const AREA_HREF_TO_PREVIEW_KEY = {
  "商品資訊/使用區域/原料接收區": "recv",
  "商品資訊/使用區域/原料儲存區": "rstore",
  "商品資訊/使用區域/原料貯存區": "rstore",
  "商品資訊/使用區域/包裝區/食品包材": "additives",
  "商品資訊/使用區域/成品儲存區": "fstore",
  "商品資訊/使用區域/成品貯存區": "fstore",
  "商品資訊/使用區域/出貨區": "ship",
  "商品資訊/使用區域/洗手消毒區": "handwash",
  "商品資訊/使用區域/洗手間": "restroom",
  "商品資訊/使用區域/廢棄物處理區": "waste",
  "商品資訊/使用區域/前處理區": "pre",
  "商品資訊/使用區域/加工|烹飪區": "cook",
  "商品資訊/使用區域/加工調理區": "cook",
  "商品資訊/使用區域/包裝區": "pack",
  "商品資訊/使用區域/員工更衣室": "locker",
  "商品資訊/使用區域/浴塵室": "clean",
  "商品資訊/使用區域/辦公區": "office",
};

const GROUP_LABEL_TO_PREVIEW_KEY = {
  洗手和手部消毒: "hand-wash",
  食品衛生化學品: "chemicals",
  器械清潔: "equipment-cleaning",
  一次性衛生耗材: "disposable",
  設備: "equipment",
  工具: "tools",
};

const GROUP_HREF_TO_PREVIEW_KEY = {
  "商品資訊/group/hand-wash": "hand-wash",
  "商品資訊/group/chemicals": "chemicals",
  "商品資訊/group/equipment-cleaning": "equipment-cleaning",
  "商品資訊/group/disposable": "disposable",
  "商品資訊/group/equipment": "equipment",
  "商品資訊/group/tools": "tools",
};

export function getB2BCategoryPreviewImage(href) {
  const normalizedHref = normalizePreviewHref(href);

  return (
    previewMatch(
      normalizedHref,
      GROUP_HREF_TO_PREVIEW_KEY,
      GROUP_PREVIEW_IMAGES,
      "group",
    ) ||
    previewMatch(
      normalizedHref,
      INDUSTRY_HREF_TO_PREVIEW_KEY,
      INDUSTRY_PREVIEW_IMAGES,
      "industry",
    ) ||
    previewMatch(
      normalizedHref,
      HUMAN_PART_HREF_TO_PREVIEW_KEY,
      HUMAN_PART_PREVIEW_IMAGES,
      "human",
    ) ||
    previewMatch(
      normalizedHref,
      AREA_HREF_TO_PREVIEW_KEY,
      AREA_PREVIEW_IMAGES,
      "area",
    )
  );
}

export function getB2BGroupPreviewImage(group) {
  const candidates = [
    group?.group_id,
    group?.groupID,
    group?.key,
    group?.label,
    group?.group_name,
    group?.groupName,
  ]
    .map((v) => String(v || "").trim())
    .filter(Boolean);

  for (const value of candidates) {
    const key = GROUP_PREVIEW_IMAGES[value]
      ? value
      : GROUP_LABEL_TO_PREVIEW_KEY[value];

    if (key && GROUP_PREVIEW_IMAGES[key]) {
      return {
        ...GROUP_PREVIEW_IMAGES[key],
        key,
        type: "group",
      };
    }
  }

  return null;
}